module.exports = __webpack_public_path__ + "static/img/code_create.c32a3a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/code_create.jpg
// module id = mnPg
// module chunks = 1